import { useTranslation } from 'react-i18next';

import { RoadBlock } from './Illustrations/RoadBlock';
import { StatusPage } from './StatusPage';

export const ServiceUnavailable = () => {
	const { t } = useTranslation('monarch');

	return (
		<StatusPage
			graphic={<RoadBlock title={t('status.blocked_image_title')} />}
			heading={t('status.unavailable_title')}
			subheading={t('status.unavailable_description')}
			status={503}
		/>
	);
};
